import { promiseAction } from "~/misc/dispatch";
import { getLoads as getLoadsApi} from "./api"
import TYPES from './types';
import create from '~/misc/create';
import { getBidsLoads } from '~/modules/bids/actions'
import { getMyBookingsAction } from '../bookings/action';
export const loadCheck = (id) => create(TYPES.CITYRATIO_CHECKED, { id });

// checkedAll
export const loadCheckedAll = () => (dispatch) => {
  dispatch({ type: TYPES.CITYRATIO_CHECKED_ALL });
}

export const showMore = (court) => (dispatch) => {
  dispatch({ type: TYPES.CITYRATIO_SHOW_MORE, payload: court });
};

// clear
export const clearChecked = () => (dispatch) => {
  dispatch({ type: TYPES.CITYRATIO_CLEAR_CHECKED });
};

export const updateChecked = () => (dispatch) => {
  dispatch({ type: TYPES.CITYRATIO_UPDATE_CHECKED });
};


const setCriteria = (query) => create(TYPES.CITYRATIO_LIST_CRITERIA, query)

export const getLoads = (formData) => (dispatch, getState) => {
  dispatch(setCriteria(formData))
  dispatch(getMyBookingsAction())
  dispatch(getBidsLoads())
  return promiseAction(
    dispatch,
    getState,
    TYPES.CITYRATIO_LIST_GET,
    getLoadsApi(getState,  formData)
  )
} 

export const sortLoads = (formData) => (dispatch, getState) => {
  dispatch(setCriteria(formData))
  dispatch(getMyBookingsAction())
  dispatch(getBidsLoads())
  return promiseAction(
    dispatch,
    getState,
    TYPES.CITYRATIO_LIST_SORT,
    getLoadsApi(getState,  formData)
  )
}

export const getMoreLoads = (formData) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  TYPES.CITYRATIO_LIST_MORE,
  getLoadsApi(getState,  formData)
)

export const loadsHideTheCompany = () => (dispatch, getState) => {
  const query = getState().cityRatioList.query;
  dispatch(getLoads(query))
};




// WEBPACK FOOTER //
// ./src/modules/cityRatioList/actions.js